import { useContext, createContext } from 'react';

const BlankslateContext = /*#__PURE__*/createContext(null);
function useBlankslate() {
  const context = useContext(BlankslateContext);
  if (!context) {
    throw new Error("useBlankslate must be used within a BlankslateProvider");
  }
  return context;
}
const Provider = BlankslateContext.Provider;

export { Provider, useBlankslate };
